import { highLevelApi } from '@sdk/main'

import type { SubmitUserFeedbackPayload } from '@sdk/payload.types'

/**
 * Submit user feedback
 */
export function submitUserFeedback(payload: SubmitUserFeedbackPayload) {
  return highLevelApi.API.request('submit_user_feedback', payload)
}
